import React, { Component } from 'react';

class CarModal extends Component
{
    render()
    {
        let date_begin = null;
        if(this.props.car.date_begin != null)
        {
            date_begin = new Date(this.props.car.date_begin*1000);
            date_begin = ("0"+date_begin.getDate()).slice(-2)+"/"+("0"+(date_begin.getMonth()+1)).slice(-2)+"/"+date_begin.getFullYear();
        }
        let date_start_diac = null;
        if(this.props.car.date_start_diac != null)
        {
            date_start_diac = new Date(this.props.car.date_start_diac*1000);
            date_start_diac = ("0"+date_start_diac.getDate()).slice(-2)+"/"+("0"+(date_start_diac.getMonth()+1)).slice(-2)+"/"+date_start_diac.getFullYear();
        }
        let date_end_diac = null;
        if(this.props.car.date_end_diac != null)
        {
            date_end_diac = new Date(this.props.car.date_end_diac*1000);
            date_end_diac = ("0"+date_end_diac.getDate()).slice(-2)+"/"+("0"+(date_end_diac.getMonth()+1)).slice(-2)+"/"+date_end_diac.getFullYear();
        }
        let date_start_ctsce = null;
        if(this.props.car.date_start_ctsce != null)
        {
            date_start_ctsce = new Date(this.props.car.date_start_ctsce*1000);
            date_start_ctsce = ("0"+date_start_ctsce.getDate()).slice(-2)+"/"+("0"+(date_start_ctsce.getMonth()+1)).slice(-2)+"/"+date_start_ctsce.getFullYear();
        }
        return (
            <div className="modal fade" id={ "cars"+this.props.index } tabIndex="-1" role="dialog" aria-labelledby={ "#carsTitle"+this.props.index } aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header bg-light">
                            <span className="modal-title h5" id={ "carsTitle"+this.props.index }>{ this.props.car.brand } { this.props.car.model }</span>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">                           
                            {   date_begin &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Date début relation</span>
                                    <span className="col-7">{ date_begin }</span>
                                </div>
                            }
                            {   this.props.car.contract &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Contrat</span>
                                    <span className="col-7">{ this.props.car.contract }</span>
                                </div>
                            }
                            {   this.props.car.finance &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Financement</span>
                                    <span className="col-7">{ this.props.car.finance }</span>
                                </div>
                            }
                            {   this.props.car.use &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Usage</span>
                                    <span className="col-7">{ this.props.car.use }</span>
                                </div>
                            }

                            <div className="mx-2 row px-3">
                                { this.props.car.replacement_interested == 0 ? "Pas intéressé" : "Intéressé" } par un véhicule de remplacement { this.props.car.replacement_same == 1 ? "identique" : "" }
                            </div>

                            {   this.props.car.place_purchase &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Acheté à</span>
                                    <span className="col-7">{ this.props.car.place_purchase }</span>
                                </div> 
                            }
                            {   this.props.car.main_user && 
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Utilisateur principal</span>
                                    <span className="col-7">{ this.props.car.main_user }</span>
                                </div>
                            }
                            {   this.props.car.payer && 
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Payeur/Financeur</span>
                                    <span className="col-7">{ this.props.car.payer }</span>
                                </div>
                            }
                            {   this.props.car.decision_maker &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Décisionnaire d'achat</span>
                                    <span className="col-7">{ this.props.car.decision_maker }</span>
                                </div> 
                            }
                            {   this.props.car.funding &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Financement</span>
                                    <span className="col-7">{ this.props.car.funding }</span>
                                </div> 
                            }
                            {   this.props.car.avg_km &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Km location</span>
                                    <span className="col-7">{ this.props.car.avg_km }  km</span>
                                </div> 
                            }
                            {   this.props.car.duration &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Durée location</span>
                                    <span className="col-7">{ this.props.car.duration } mois</span>
                                </div> 
                            }
                            {   this.props.car.budget &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Budget</span>
                                    <span className="col-7">{ this.props.car.budget } €</span>
                                </div> 
                            }

                            {   this.props.car.description &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Description</span>
                                    <span className="col-7">{ this.props.car.description }</span>
                                </div> 
                            }
                            {   this.props.car.agent &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Agent</span>
                                    <span className="col-7">{ this.props.car.agent }</span>
                                </div>
                            }
                            
                            <span className="mx-2 my-2 row px-3 py-1 h4 bg-light border-bottom">
                                DIAC
                            </span>
                            {   date_start_diac &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Date d'entrée en gestion DIAC</span>
                                    <span className="col-7">{ date_start_diac }</span>
                                </div>
                            }
                            {   date_end_diac &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Date de fin de contrat REELLE DIAC</span>
                                    <span className="col-7">{ date_end_diac }</span>
                                </div>
                            }
                            {   this.props.car.diac_contract_number &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Numéro de contrat DIAC</span>
                                    <span className="col-7">{ this.props.car.diac_contract_number }</span>
                                </div>
                            }
                            {   this.props.car.diac_market &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Marché DIAC</span>
                                    <span className="col-7">{ this.props.car.diac_market }</span>
                                </div>
                            }
                            {   this.props.car.diac_commercial_offer &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Offre commerciale DIAC</span>
                                    <span className="col-7">{ this.props.car.diac_commercial_offer }</span>
                                </div>
                            }
                            {   this.props.car.diac_duration &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Durée DIAC</span>
                                    <span className="col-7">{ this.props.car.diac_duration } mois</span>
                                </div>
                            }
                            {   this.props.car.diac_insurance &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Prestations assurances DIAC</span>
                                    <span className="col-7">{ this.props.car.diac_insurance}</span>
                                </div>
                            }
                            {   this.props.car.diac_insurance_number != null &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Nombre d'assurances DIAC</span>
                                    <span className="col-7">{ this.props.car.diac_insurance_number }</span>
                                </div>
                            }
                            {   this.props.car.diac_egvo_number != null &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Nb EGVO DIAC</span>
                                    <span className="col-7">{ this.props.car.diac_egvo_number }</span>
                                </div>
                            }
                            {   this.props.car.diac_selling_price &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Prix de Vente DIAC</span>
                                    <span className="col-7">{ this.props.car.diac_selling_price } €</span>
                                </div>
                            }
                            {   this.props.car.diac_ca != null &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">CA DIAC</span>
                                    <span className="col-7">{ this.props.car.diac_ca } €</span>
                                </div>
                            }
                            {   this.props.car.diac_er != null &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">ER DIAC</span>
                                    <span className="col-7">{ this.props.car.diac_er } €</span>
                                </div>
                            }
                            {   this.props.car.diac_insurable != null &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Barême assurable DIAC</span>
                                    <span className="col-7">{ this.props.car.diac_insurable == 0 ? "Non" : "Oui" }</span>
                                </div>
                            }
                            <span className="mx-2 my-2 row px-3 py-1 h4 bg-light border-bottom">
                                Contrats services
                            </span>
                            {   date_start_ctsce &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Date de début de contrat CtSce</span>
                                    <span className="col-7">{ date_start_ctsce }</span>
                                </div>
                            }
                            {   this.props.car.contract_number_ctsce &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">N° de contrat CtSce</span>
                                    <span className="col-7">{ this.props.car.contract_number_ctsce }</span>
                                </div>
                            }
                            {   this.props.car.scale_code_ctsce &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Code barème CtSce</span>
                                    <span className="col-7">{ this.props.car.scale_code_ctsce }</span>
                                </div>
                            }
                            {   this.props.car.maintenance_class_ctsce &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Classe entretien CtSce</span>
                                    <span className="col-7">{ this.props.car.maintenance_class_ctsce }</span>
                                </div>
                            }
                            {   this.props.car.product_family_ctsce &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Code famille produit CtSce</span>
                                    <span className="col-7">{ this.props.car.product_family_ctsce }</span>
                                </div>
                            }
                            {   this.props.car.duration_ctsce &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Durée souscrite CtSce</span>
                                    <span className="col-7">{ this.props.car.duration_ctsce } mois</span>
                                </div>
                            }
                            {   this.props.car.km_ctsce &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Km souscrit CtSce</span>
                                    <span className="col-7">{ this.props.car.km_ctsce } km</span>
                                </div>
                            }
                            {   this.props.car.supplier_ctsce &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Nom fournisseur CtSce</span>
                                    <span className="col-7">{ this.props.car.supplier_ctsce }</span>
                                </div>
                            } 
                            {   this.props.car.market_type_ctse &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Type Marché CtSce</span>
                                    <span className="col-7">{ this.props.car.market_type_ctse }</span>
                                </div>
                            }                                      
                            {   this.props.car.product_detail &&
                                <div className="mx-2 row">
                                    <span className="h6 text-muted col-5">Produit détaillé CtSce</span>
                                    <span className="col-7">{ this.props.car.product_detail }</span>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
            
        );
    }
}

export default CarModal;



// WEBPACK FOOTER //
// ./src/Components/Car/CarModal.js